<template>
  <div>
    <menu-pae />

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item">Tramitados</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-fluid mt-2">
      <filtro-pesquisa-tramitados class="p-2"
        :rowsNumber="10"
        :eventBusDataName="eventBusDataName"
        :eventBusPaginationName="eventBusPaginationName"/>
    </div>

    <div class="container-xl">
      <data-table-consulta
        :colNames="colNames"
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
        :dataTableColumn="dataTableColumn"
        :subtable="subtable"
        :colWidthSubTable="colWidthSubTable">
        <template v-slot="slotProps">
          <td style="text-align: center; width: 100px !important; white-space: nowrap;">
              <i
                v-if="disableButton(slotProps.itemData)"
                class="fa fa-search fa-1-5x m-1 link"
                aria-hidden="true"
                v-on:click="visualizar(slotProps.itemData)"
              ></i>
              <i
                v-if="disableButton(slotProps.itemData)"
                v-tooltip.auto-start="`Imprimir Guia de Tramitação ${slotProps.itemData.lote}`"
                class="fa fa-print fa-1-5x text-info m-1 link"
                aria-hidden="true"
                v-on:click="imprimirGuia(slotProps.itemData)"
              ></i>
              <i
                v-if="slotProps.itemData && slotProps.itemData.atributos ? slotProps.itemData.atributos.tipoProtocolo === 'Processo' : ''"
                v-tooltip.auto-start="`Imprimir Etiqueta da Tramitação ${slotProps.itemData.atributos.numeroProcessoComMascara}`"
                class="fa fa-archive fa-1-5x text-info m-1 link"
                aria-hidden="true"
                v-on:click="abrirEtiquetas(slotProps.itemData)"
              ></i>
          </td>
        </template>
        <template v-slot:subtable="subtable">
          <i
            v-tooltip.auto-start="`Visualizar protocolo ${subtable.itemData.data ? subtable.itemData.data.protocolo : ''}`"
            class="fa fa-search fa-1-5x link m-1 text-info"
            aria-hidden="true"
            v-on:click="visualizarApensado(subtable.itemData)"
          ></i>
        </template>
      </data-table-consulta>
    </div>

    <modal ref="etiquetas" width="750px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Etiquetas</h4>
          <i class="fa fa-times fa-1-7x m-2 link" @click="$refs.etiquetas.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <data-table-consulta-comp class="p-2"
            :colNames="etiquetas.colNames"
            :eventBusDataName="etiquetas.eventBusDataName"
            :eventBusDataPaginationName="etiquetas.eventBusPaginationName"
            :dataTableColumn="etiquetas.dataTableColumn"
            :colWidth="etiquetas.colWidth">
            <template v-slot="slotProps">
              <td style="text-align: center; width: 100px !important;">
                <i
                  v-tooltip.auto-start="`Baixar Etiqueta - Volume ${slotProps.itemData.numero}`"
                  class="fa fa-download fa-1-5x text-info link mr-2"
                  aria-hidden="true"
                  v-on:click="downloadEtiqueta(slotProps.itemData)"
                ></i>
              </td>
            </template>
          </data-table-consulta-comp>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import filtroPesquisaTramitados from '@/components/consulta-processo/FiltroPesquisaTramitados.vue'
import dataTableConsulta from '@/components/data-table-consulta/DataTableConsulta'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import { componentIsVisible, rules, VALID } from '@/uteis/action/permissao'
import modal from '@/components/shared/Modal.vue'
import DataValues from '@/components/data-table-consulta/DataValues'
import eventBus from '@/uteis/eventBus'

import VirtusRepositoryService from '@/services/VirtusRepositoryService'
import VirtusService from '@/services/VirtusService'

export default {
  name: 'tramitados',
  components: {
    menuPae,
    filtroPesquisaTramitados,
    dataTableConsultaComp,
    dataTableConsulta,
    modal
  },

  data () {
    return {
      etiquetas: {
        eventBusDataName: 'consultaVolumes',
        eventBusPaginationName: 'consultaVolumesDataPagination',
        colNames: ['Data', 'Número Volume', 'Ações'],
        colWidth: [30, 40, 30],
        dataTableColumn: ['data', 'numero'],
        numeroProtocolo: ''
      },
      colWidthSubTable: [50, 50, 5],
      colNames: ['Protocolo', 'Assunto', 'Destinatário', 'Data de Envio', 'Ações'],
      eventBusDataName: 'consultaProcessoTramitados',
      eventBusPaginationName: 'consultaProcessoTramitadosDataPagination',
      dataTableColumn: [
        {
          column: 'numeroProcesso',
          converter: 'protocolo'
        },
        'atributos.assunto',
        'destino.titulo',
        {
          column: 'data',
          converter: 'localDate'
        }
      ],
      subtable: {
        field: 'atributos.apensados',
        column: [
          {
            column: 'protocolo',
            converter: 'protocolo'
          }, {
            $set: 'Apenso'
          }
        ]
      }
    }
  },

  created () {
    this.virtusRepositoryService = new VirtusRepositoryService()
    this.service = new VirtusService()
  },

  methods: {
    visualizarApensado (obj) {
      var data = obj.data
      this.$router.push({
        name: 'visualizadorProcesso',
        query: {
          numeroProcesso: data.protocolo.replace(/\//g, ''),
          disableMenuProcesso: true,
          anableButtonEditar: false
        }
      })
    },

    visualizar (obj) {
      this.$router.push({
        name: 'visualizadorProcesso',
        query: {
          disableMenuProcesso: true,
          numeroProcesso: obj.numeroProcesso.replace(/\//g, ''),
          anableButtonEditar: false
        }
      })
    },

    abrirEtiquetas (obj) {
      if (!obj || !obj.atributos) {
        return false
      }
      this.etiquetas.numeroProtocolo = obj.atributos.numeroProcesso
      this.$refs.etiquetas.openModal()
      this.service.buscarVolumesDoProcesso(obj.atributos.numeroProcesso).then((data) => {
        var numeroPagina = 1
        var rowsNumber = 100

        var dataValues = new DataValues(data.volumes, numeroPagina, rowsNumber)
        eventBus.$emit(this.etiquetas.eventBusDataName, dataValues)
      }).catch((error) => {
        console.log(error)
      })
    },

    imprimirGuia (obj) {
      if (!obj.lote) {
        return false
      }

      this.virtusRepositoryService.dowloadGuiTramite(obj.lote).then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' })

        var filename = `guia${obj.lote}.pdf`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob)
        } else {
          var fileURL = URL.createObjectURL(blob)
          window.open(fileURL, filename)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    downloadEtiqueta (obj) {
      if (!obj.numero) {
        return false
      }
      const numeroVolume = obj.numero

      this.virtusRepositoryService.dowloadEtiqueta(this.etiquetas.numeroProtocolo, numeroVolume).then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' })

        var filename = `etiqueta${this.etiquetas.numeroProtocolo}.pdf`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob)
        } else {
          var fileURL = URL.createObjectURL(blob)
          window.open(fileURL, filename)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    disableButton (obj) {
      if (!obj.atributos) {
        return false
      }

      return true
    },

    anableButtonEditar (obj) {
      const { EDITAR_PROTOCOLO_TRAMITADO } = rules
      if (this.isApensado(obj) || this.isAnexado(obj)) {
        return false
      }

      return componentIsVisible(EDITAR_PROTOCOLO_TRAMITADO) === VALID
    },
    isApensado: (obj) => obj.apensadoEm && obj.apensadoEm !== '',
    isAnexado: (obj) => obj.anexadoEm && obj.anexadoEm !== ''
  }
}
</script>

<style scoped>
</style>
